import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { getDefaultState } from './types';

const state = getDefaultState();
// Removed during scalability changes as its not clear what this is doing
// state.currentUser = loadState().currentUser || null;

export default {
  state,
  getters,
  mutations,
  actions
};
